import { useT } from "../i18n/useT";
import { useSettings } from "./useSettings";

export function AppearanceCard() {
  const t = useT();
  const [s, setS] = useSettings();

  const handleColorChange = (color: string) => {
    console.log("Color changed to:", color);
    setS({ customGlassColor: color });
  };

  const handleThemeChange = (theme: "system" | "light" | "dark") => {
    console.log("Theme changed to:", theme);
    setS({ themeMode: theme });
  };

  const handleUIStyleChange = (style: "standard" | "liquidGlass" | "liquidGlassCustom") => {
    console.log("UI Style changed to:", style);
    setS({ uiStyle: style });
  };

  return (
    <div className="settings-card appearance-card">
      <h3>{t("settings.appearance")}</h3>

      <div className="block">
        <div className="muted small">{t("settings.theme")}</div>
        <div className="segmented">
          <button
            className={`seg ${s.themeMode === "system" ? "is-active" : ""}`}
            onClick={() => handleThemeChange("system")}
          >
            {t("settings.theme.system")}
          </button>
          <button
            className={`seg ${s.themeMode === "light" ? "is-active" : ""}`}
            onClick={() => handleThemeChange("light")}
          >
            {t("settings.theme.light")}
          </button>
          <button
            className={`seg ${s.themeMode === "dark" ? "is-active" : ""}`}
            onClick={() => handleThemeChange("dark")}
          >
            {t("settings.theme.dark")}
          </button>
        </div>
      </div>

      <div className="block">
        <div className="muted small">{t("settings.uiStyle")}</div>
        <div className="segmented">
          <button
            className={`seg ${s.uiStyle === "standard" ? "is-active" : ""}`}
            onClick={() => handleUIStyleChange("standard")}
          >
            {t("settings.uiStyle.standard")}
          </button>
          <button
            className={`seg ${s.uiStyle === "liquidGlass" ? "is-active" : ""}`}
            onClick={() => handleUIStyleChange("liquidGlass")}
          >
            {t("settings.uiStyle.glass")}
          </button>
          <button
            className={`seg ${s.uiStyle === "liquidGlassCustom" ? "is-active" : ""}`}
            onClick={() => handleUIStyleChange("liquidGlassCustom")}
            title="Custom glass color mode"
          >
            Custom
          </button>
        </div>
      </div>

      {s.uiStyle === "liquidGlassCustom" && (
        <div className="block custom-color-picker">
          <label className="muted small" htmlFor="glass-color-input">
            Glass Color / Цвет стекла
          </label>
          <div className="color-picker-wrapper">
            <input
              id="glass-color-input"
              type="color"
              value={s.customGlassColor || "#6bffff"}
              onChange={(e) => handleColorChange(e.target.value)}
              className="color-input"
            />
            <div className="color-preview" style={{ backgroundColor: s.customGlassColor || "#6bffff" }}></div>
            <span className="color-hex">{s.customGlassColor || "#6bffff"}</span>
          </div>
          <div className="color-presets">
            <button 
              className="preset-btn"
              style={{ backgroundColor: "#6bffff" }}
              onClick={() => handleColorChange("#6bffff")}
              title="Cyan"
            ></button>
            <button 
              className="preset-btn"
              style={{ backgroundColor: "#ff6ba3" }}
              onClick={() => handleColorChange("#ff6ba3")}
              title="Pink"
            ></button>
            <button 
              className="preset-btn"
              style={{ backgroundColor: "#6bff6b" }}
              onClick={() => handleColorChange("#6bff6b")}
              title="Green"
            ></button>
            <button 
              className="preset-btn"
              style={{ backgroundColor: "#ffb36b" }}
              onClick={() => handleColorChange("#ffb36b")}
              title="Orange"
            ></button>
            <button 
              className="preset-btn"
              style={{ backgroundColor: "#b36bff" }}
              onClick={() => handleColorChange("#b36bff")}
              title="Purple"
            ></button>
            <button 
              className="preset-btn"
              style={{ backgroundColor: "#6ba3ff" }}
              onClick={() => handleColorChange("#6ba3ff")}
              title="Blue"
            ></button>
          </div>
        </div>
      )}

      <div className="block">
        <button className="btn ghost" onClick={() => setS({ reduceMotion: !s.reduceMotion })}>
          {s.reduceMotion ? t("settings.motion.reduce.on") : t("settings.motion.reduce.off")}
        </button>
        <div className="muted small">{t("settings.motion.hint")}</div>
      </div>
    </div>
  );
}

